<template>
    <data-table
        action-button-text="سرویس/محصول جدید"
        action-button-icon="add"
        show-select
        remove-key="service"
        export-key="services"
        settings-key="services"
        @click:actionButton="router.push({path: '/settings/services/new' })"
        @getList="getList"
        @deleted="system.setSystemDefaults(true); auth.fetchUser(true);"
        :rowClick="(row) => router.resolve({path: `/settings/services/${row.id}`})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    >
        <template #item.departments="{value}">
            <span v-if="value.length == 1">{{ value[0].name }}</span>
            <v-menu v-else>
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon="icon-orgg" color="primary" variant="text"></v-btn>
                </template>
                <div class="py-3 px-8 bg-white elevation-1">
                    <p v-for="item in value" class="text-small text-secondary font-weight-bold my-2">{{ item.name }}</p>
                </div>
            </v-menu>
        </template>
    </data-table>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useRouter } from 'vue-router';

defineOptions({
    title: "سرویس‌ها/محصولات",
    validate(context) {
        return context.auth.user.full_admin;
    },
})
const api = useApi();
const router = useRouter();
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 180,
    },
    {
        title: 'توضیحات',
        key: 'description',
        value: (item) => item.description,
        minWidth: 220,
    },
    {
        title: 'دپارتمان ها',
        key: 'departments',
        exportValue: (item) => item.departments.map(x => x.name).join(', '),
        minWidth: 160,
        filterable: false,
        sortable: false,
    },
    {
        title: 'نوع',
        key: 'is_product',
        value: (item) => item.is_product ? 'محصول' : 'سرویس‌ها',
        minWidth: 220,
    },
    {
        title: 'وضعیت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 70,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
})
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.serviceList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.serviceList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
